<a
    [href]="actualUrl"
    class="pill pill--website">
    <i class="uil uil-globe"></i>
    <span *ngIf="showUrl">{{ websiteUrl }}</span>
    <span *ngIf="!showUrl">website</span>
</a>
